// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + "." + {"102":"7789b25c","133":"252f988b","182":"11ef6de1","453":"9c8316ed"}[chunkId] + ".chunk.js";
};